export default {
  data() {
    return {
      redirect_data: { url: null, text: null }
    }
  }
}
